<template>
  <div class="home-wrapper">
    <AccountSettings />
    <v-icon @click="sign_out" class="logout"></v-icon>

    <v-container fluid>
      <v-layout row align-start pb-1>
        <v-flex xs5>
          <ProfilePic
            :image="user_data.big_thumbnail"
            @upload="saveData"
            :accountActive="!user_data.accountNotActivated"
          />
        </v-flex>
        <v-flex @click="bottomSheet = 'view_profile'" xs7 pl-2 class="text-xs-left">
          <h3 class="name-with-settings">
            <span :title="user_data.name">{{ user_data.name }}</span>
            <v-icon ml-1>mdi-pencil</v-icon>
          </h3>
          <h4 class="header-thin">{{ user_data.trainer_type }}</h4>
          <h4 class="header-thin">
            {{
              user_data.no_team === true || user_data.no_team === 'nein'
                ? user_data.currentTeam
                : 'Vereinslos'
            }}
          </h4>
          <h5>
            <flag class="flag" :iso="user_data.nationality" />
            {{ getNationality }}
          </h5>
        </v-flex>
      </v-layout>

      <v-layout mt-4 mb-1 align-start>
        <v-flex xs12 py-2 px-3 class="matches-box">
          <v-layout mb-2>
            <v-flex xs3>
              <h3>Matches</h3>
            </v-flex>
            <v-flex xs9 class="text-xs-right" style="font-size: 12px">
              <div class="mt-1">
                <span
                  class="d-inline-block filter-span"
                  :class="{ 'filter-span-active': selectedMatchType === 'all' }"
                  @click="selectedMatchType = 'all'"
                  >Alle</span
                >
                <span
                  class="d-inline-block filter-span"
                  :class="{ 'filter-span-active': selectedMatchType === 'teams' }"
                  @click="selectedMatchType = 'teams'"
                  >Vereine</span
                >
                <span
                  class="d-inline-block"
                  :class="{ 'filter-span-active': selectedMatchType === 'scout' }"
                  @click="selectedMatchType = 'scout'"
                  >Scouts</span
                >
              </div>
            </v-flex>
          </v-layout>
          <div
            v-if="filteredPlayerMatches && filteredPlayerMatches.length"
            class="scrolling-wrapper-flexbox"
            style="margin-top: 10px"
          >
            <MatchPreview
              @click="openMatchedProfile(profile)"
              class="player-preview"
              v-for="profile in filteredPlayerMatches"
              :key="profile.chat_id"
              :picture="profile.logo"
              :msg="profile.lastMessage"
              :chat-id="profile.chat_id"
              :name="profile.team ? profile.team : profile.name"
              :details="profile.contactByDetails"
              :showRemoveButton="true"
              :selectedMatch="profile"
            ></MatchPreview>
          </div>
          <v-flex my-3 v-else class="text-xs-center">
            <v-icon large color="white">mdi-volleyball</v-icon>
            <h4 style="color: white">Aktuell keine Matches vorhanden.</h4>
          </v-flex>
        </v-flex>
      </v-layout>

      <v-layout mt-4 align-start>
        <v-flex xs12 py-2 px-3 class="connect-box">
          <h3>Connect-Anfragen</h3>
          <small>Bestätigung durch Verein steht noch aus.</small>
          <div
            v-if="appliedTeamsWithNoMatch.length && !loadingConnectQuestions"
            class="scrolling-wrapper-flexbox"
            style="margin-top: 10px"
          >
            <ConnectPreview
              class="player-preview"
              v-for="appliedTeam in appliedTeamsWithNoMatch"
              :key="appliedTeam.id"
              :showRemoveButton="true"
              :selectedProfile="appliedTeam"
              :picture="
                appliedTeam.big_thumbnail
                  ? appliedTeam.big_thumbnail
                  : appliedTeam.profile_pic
              "
              :name="appliedTeam.team_name"
              :detail1="appliedTeam.category.league"
              :detail2="appliedTeam.verband"
              :nationality="appliedTeam.nationality"
              @click="openProfile(appliedTeam, 'showTeam')"
              @updateAppliedTeams="updateAppliedTeams($event)"
            ></ConnectPreview>
          </div>
          <div class="full-spinner" v-else-if="loadingConnectQuestions">
            <v-progress-circular indeterminate color="green"></v-progress-circular>
          </div>
          <v-flex my-3 v-else class="text-xs-center">
            <v-icon large>mdi-chat-processing-outline</v-icon>
            <h4 style="color: grey">Aktuell keine offenen Connect-Anfragen.</h4>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- <div class="button-box">
      <div class="button-wrapper">
        <v-btn color="white" @click="bottomSheet = 'search_settings'" class="menu-button main main-big mb-3">
          <v-icon>filter</v-icon>
        </v-btn>
        <label class="label-big">Matchingeinstellungen</label>
      </div>
    </div> -->

    <v-card :class="['bottom-sheet', { active: bottomSheet !== 'hidden' }]">
      <v-icon @click="closeMenu" class="closeBtn">keyboard_backspace</v-icon>
      <div v-if="bottomSheet === 'profile_edit'" class="settings">
        <v-tabs
          class="tabs"
          fixed-tabs
          background-color="white"
          slider-color="light-green accent-4"
        >
          <v-tab href="#Trainerdaten">Trainerdaten</v-tab>
          <v-tab href="#Karriere">Karriere</v-tab>
          <v-tab href="#Gallery">Galerie</v-tab>
          <v-tabs-items v-model="tab_mehr" :touchless="true">
            <v-tab-item :value="'Karriere'">
              <div class="overview-profile" flat>
                <v-list>
                  <v-list-group
                    v-for="(item, i) in user_data.history"
                    :key="i"
                    v-model="item.active"
                    no-action
                  >
                    <template v-slot:activator>
                      <div class="history-wrapper list-name">
                        <h2
                          v-text="
                            `Saison ${item.season ? item.season : 'bitte angeben'}`
                          "
                        ></h2>
                      </div>
                    </template>

                    <div class="history-content">
                      <v-icon
                        @click="deleteEntry(i)"
                        class="delete"
                        color="red"
                      ></v-icon>
                      <div class="history-column">
                        <label>Saison</label>
                        <v-select
                          :items="$store.state.seasons"
                          color="green"
                          placeholder="2018/2019"
                          v-model="item.season"
                        ></v-select>
                      </div>
                      <div class="history-column">
                        <label>Verein</label>
                        <v-text-field color="green" v-model="item.team"></v-text-field>
                      </div>
                      <div class="history-column">
                        <label>Altersklasse</label>
                        <v-select
                          :items="$store.state.age_classes"
                          color="green"
                          v-model="item.class"
                        ></v-select>
                      </div>
                      <div class="history-column">
                        <label>Funktion</label>
                        <v-select
                          :items="$store.state.trainer_types"
                          color="green"
                          v-model="item.trainer_function"
                        ></v-select>
                      </div>
                      <div class="history-column">
                        <label>Region/Verband</label>
                        <v-select
                          color="green"
                          :items="$store.state.verband"
                          v-model="item.verband"
                        ></v-select>
                      </div>
                      <div class="history-column">
                        <label v-if="item.verband">Liga</label>
                        <v-select
                          v-if="item.verband"
                          color="green"
                          :items="$store.state.filter_leagues[item.verband]"
                          item-text="league"
                          item-value="league"
                          return-object
                          v-model="item.league"
                        ></v-select>
                      </div>

                      <div class="history-column">
                        <label>Spiele</label>
                        <v-text-field
                          color="green"
                          v-model="item.games_player"
                        ></v-text-field>
                      </div>
                      <div class="history-column">
                        <label>Siege</label>
                        <v-text-field color="green" v-model="item.wins"></v-text-field>
                      </div>
                      <div class="history-column">
                        <label>Unentschieden</label>
                        <v-text-field color="green" v-model="item.tie"></v-text-field>
                      </div>
                      <div class="history-column">
                        <label>Niederlagen</label>
                        <v-text-field color="green" v-model="item.lost"></v-text-field>
                      </div>
                      <div class="history-column">
                        <label>Tore</label>
                        <v-text-field color="green" v-model="item.goals"></v-text-field>
                      </div>
                      <div class="history-column">
                        <label>Gegentore</label>
                        <v-text-field
                          color="green"
                          v-model="item.goal_against"
                        ></v-text-field>
                      </div>
                    </div>
                  </v-list-group>
                </v-list>
                <v-btn
                  @click="user_data.history.push({ name: null })"
                  class="primary-btn"
                  >Neuer Eintrag</v-btn
                >
              </div>
            </v-tab-item>
            <v-tab-item :value="'Trainerdaten'">
              <div class="overview-profile" flat>
                <label>Vor- u. Nachname</label>
                <v-text-field
                  color="green"
                  v-model="user_data.name"
                  solo
                ></v-text-field>
                <label>Geburtsdatum</label>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  full-width
                  color="green"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      color="green"
                      v-model="formatDate"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    color="green"
                    ref="picker"
                    v-model="user_data.age"
                    :max="new Date().toISOString().substr(0, 10)"
                    min="1950-01-01"
                  ></v-date-picker>
                </v-menu>
                <label>Geschlecht</label>
                <v-select
                  attach
                  color="green"
                  :items="sex"
                  v-model="user_data.sex"
                  solo
                ></v-select>
                <label>Nationalität</label>
                <v-autocomplete
                  :no-data-text="'Keine Einträge vorhanden'"
                  :items="$store.state.nationalities"
                  item-text="item_text"
                  item-value="id"
                  color="green"
                  name="nationalities"
                  v-model="user_data.nationality"
                  solo
                ></v-autocomplete>

                <label>Wohnsitz (Land)</label>
                <v-autocomplete
                  :items="$store.state.countries"
                  color="green"
                  v-model="user_data.living_in_country"
                  solo
                  attach
                ></v-autocomplete>

                <label>Sprachen</label>
                <v-select
                  v-model="user_data.languages"
                  color="green"
                  :items="$store.state.languages"
                  chips
                  multiple
                ></v-select>
                <label>Trainertyp</label>
                <v-select
                  color="green"
                  :items="trainer_types"
                  v-model="user_data.trainer_type"
                  solo
                ></v-select>

                <label>Trainerlizenz</label>
                <v-select
                  color="green"
                  :items="license"
                  v-model="user_data.license"
                  solo
                ></v-select>

                <label v-if="user_data.license === 'Eigene Angabe'"
                  >Eigene Angabe zur Lizenz</label
                >
                <v-text-field
                  v-if="user_data.license === 'Eigene Angabe'"
                  color="green"
                  v-model="user_data.custom_license"
                  solo
                ></v-text-field>

                <label>Trainer/in seit</label>
                <v-menu
                  ref="since_menu"
                  v-model="since_menu"
                  locale="de"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      color="green"
                      v-model="formatSinceDate"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    color="green"
                    locale="de"
                    v-model="user_data.trainer_since"
                    type="month"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      min="1900-01-01"
                      :max="new Date().toISOString().substr(0, 10)"
                      color="green white--text"
                      @click="$refs.since_menu.save(user_data.trainer_since)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-menu>

                <h2 class="text-xs-left">Trainerstatus</h2>
                <v-switch
                  color="green"
                  v-model="user_data.no_team"
                  :label="user_data.no_team ? 'Aktiv' : 'Vereinslos'"
                ></v-switch>
                <label>
                  <span v-if="user_data.no_team">Aktueller</span>
                  <span v-else>Letzter</span>
                  Verein
                </label>
                <v-text-field
                  color="green"
                  v-model="user_data.currentTeam"
                  solo
                ></v-text-field>
                <label>Region/Verband</label>
                <v-select
                  color="green"
                  :items="$store.state.verband"
                  v-model="user_data.verband"
                  solo
                ></v-select>

                <label v-if="$store.state.user_data.verband">Liga</label>
                <v-select
                  v-if="$store.state.user_data.verband"
                  color="green"
                  :items="$store.state.filter_leagues[user_data.verband]"
                  item-text="league"
                  item-value="category"
                  return-object
                  v-model="user_data.category"
                  solo
                ></v-select>
                <h2 class="text-xs-left">Links</h2>
                <label for>Link Transfermarkt-Profil (optional)</label>
                <v-text-field
                  color="green"
                  v-model="user_data.transfermarkt"
                  hint="Kopiere den Link von deinem Transfermarkt-Profil."
                  solo
                ></v-text-field>

                <label>Link FuPa-Profil (optional)</label>
                <v-text-field
                  color="green"
                  v-model="user_data.fupa"
                  hint="Kopiere den Link von deinem FuPa-Profil."
                  solo
                ></v-text-field>

                <label>Link Facebook-Profil (optional)</label>
                <v-text-field
                  color="green"
                  v-model="user_data.facebook"
                  hint="Kopiere den Link von deinem Facebook-Profil."
                  solo
                ></v-text-field>

                <label>Link Instagram-Profil (optional)</label>
                <v-text-field
                  color="green"
                  v-model="user_data.instagram"
                  hint="Kopiere den Link von deinem Instagram-Profil."
                  solo
                ></v-text-field>

                <v-list>
                  <v-list-group no-action>
                    <template v-slot:activator>
                      <h2>Mehr Infos</h2>
                    </template>

                    <div class="overview-profile" flat>
                      <label>Bio</label>
                      <v-textarea
                        placeholder="Was zeichnet dich als Trainer aus?"
                        color="green"
                        v-model="user_data.bio"
                        solo
                      />
                      <label>Geburtsort</label>
                      <v-text-field
                        color="green"
                        v-model="user_data.birthplace"
                        solo
                      ></v-text-field>

                      <label>Bundesland</label>
                      <v-text-field
                        color="green"
                        v-model="user_data.living_in_state"
                        solo
                      ></v-text-field>

                      <label>Größte Erfolge bisher</label>
                      <v-textarea
                        placeholder="Aufstiegstrainer in..."
                        color="green"
                        v-model="user_data.successes"
                        solo
                      />
                      <label>Besondere Auszeichnungen</label>
                      <v-textarea
                        placeholder="Trainer der Saison, Trainer des Jahres..."
                        color="green"
                        :items="sex"
                        v-model="user_data.prices"
                        solo
                      ></v-textarea>
                    </div>
                  </v-list-group>
                </v-list>
              </div>
            </v-tab-item>
            <v-tab-item :value="'Gallery'">
              <GalleryTab @save-data="saveImage" />
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </div>
    </v-card>

    <!-- <TrainerSearchTeam
      :show="bottomSheet === 'search_settings'"
      :showSaveButton="false"
      @save-and-close="closeMenu"
    /> -->

    <Profile
      :bottomSheet="bottomSheet"
      @close="closeMenu"
      @open-profile-edit="bottomSheet = 'profile_edit'"
    />

    <v-dialog v-model="accountNeedVerification" max-width="290">
      <v-card class="text-left">
        <v-card-title class="headline">Verifizierung Traineraccount</v-card-title>

        <v-card-text
          >Damit auch du den begehrten <b>blauen C4T-Ring</b> für dein Profilbild
          erhältst, und somit in den Suchergebnissen von Vereinen oder Scouts vorrangig
          gelistet wirst, musst du deinen Account nur noch verifizieren.</v-card-text
        >

        <v-card-actions style="justify-content: center">
          <v-btn color="blue white--text" text @click="verifyAccount"
            >Jetzt verifizieren</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <MatchSheetTeam
      v-if="showTeam && selectedProfile.id"
      :selectedProfile="selectedProfile"
      @close="showTeam = false"
      :show="showTeam"
      :showMatchButtons="false"
    ></MatchSheetTeam>

    <ScoutSheet
      v-if="showScout && selectedProfile.id"
      :selectedProfile="selectedProfile"
      @close="showScout = false"
      :show="showScout"
    ></ScoutSheet>
  </div>
</template>

<script>
import moment from 'moment';
import { db } from '@/db';
import ProfilePic from '@/components/home/ProfilePic';
import AccountSettings from '@/components/settings/AccountSettings';
import MatchPreview from '../../components/home/MatchPreview';
import ConnectPreview from '../../components/home/ConnectPreview';
import Profile from '@/components/trainers/Profile';
import MatchSheetTeam from '../../components/match/TeamSheet';
import ScoutSheet from '../../components/match/ScoutSheet';
import GalleryTab from '../../components/settings/edit/GalleryTab';

import match from '../../mixins/match';
import home from '../../mixins/home';
import common from '../../mixins/common';

export default {
  name: 'home-trainer',

  components: {
    ProfilePic,
    AccountSettings,
    MatchPreview,
    ConnectPreview,
    Profile,
    MatchSheetTeam,
    ScoutSheet,
    GalleryTab,
  },

  mixins: [match, home, common],

  data: () => ({
    dialog: false,
    since_menu: false,
    menu: false,
    tab: null,
    tab_mehr: null,
    bottomSheet: 'hidden',
    profile_edit: false,
    search_settings: false,
    view_profile: false,
    trainer_types: [
      'Cheftrainer/in',
      'Co-Trainer/in',
      'Torwarttrainer/in',
      'Fitnesstrainer/in',
      'Athletiktrainer/in',
      'Mentaltrainer/in',
    ],
    license: [
      'Keine Lizenz',
      'Jugend-Elite-Lizenz',
      'C-Lizenz',
      'B-Lizenz',
      'A-Lizenz',
      'Fußballlehrer',
      'Eigene Angabe',
    ],
    email: '',
    password: '',
    picture: null,
    uploading: false,
    items: ['Profi', 'Amateur', 'Halbprofi'],
    foot: ['Rechts', 'Links', 'Beide'],
    sex: ['Männlich', 'Weiblich'],
    selectedProfile: {},
    showTeam: false,
    showScout: false,
  }),

  computed: {
    formatSinceDate() {
      return this.user_data.trainer_since
        ? moment(this.user_data.trainer_since).format('MM/YYYY')
        : '';
    },
  },

  methods: {
    openProfile(data, type) {
      this.selectedProfile = data;
      this[type] = true;
    },

    async openMatchedProfile(matchChat) {
      console.log(matchChat);
      if (matchChat.contactByDetails) {
        this.selectedProfile = {};
        this.$store.state.loading = true;
        const collection =
          matchChat.contactByDetails.type === 'scout' ? 'scouts' : 'teams';
        const type = collection === 'teams' ? 'showTeam' : 'showScout';
        const contactedBy = await db
          .collection(collection)
          .doc(matchChat.team_id)
          .get({ source: 'server' })
          .then((snapshot) => snapshot.data());

        this.selectedProfile = contactedBy;
        this[type] = true;

        this.$store.state.loading = false;
      }
    },

    deleteEntry(i) {
      const oldHistory = this.$store.state.user_data.history;
      const remove = oldHistory[i];
      const filteredItems = oldHistory.filter((item) => item !== remove);
      this.$store.state.user_data.history = filteredItems;
    },
    sign_out() {
      this.$store.state.logout_dialog = true;
    },
    saveImage() {
      db.collection('trainers')
        .doc(this.$store.state.user_data.id)
        .update({ ...this.$store.state.user_data })
        .then(() => {
          this.$forceUpdate();
        });
    },
    saveData() {
      this.clearLinks();
      this.search_settings = !this.search_settings;

      db.collection('trainers')
        .doc(this.$store.state.user_data.id)
        .update({ ...this.$store.state.user_data })
        .then(() => {
          this.$forceUpdate();
        });
    },
  },

  beforeMount() {
    this.initialData = JSON.stringify(this.$store.state.user_data);
    this.getAppliedTeamWithNoMatches(this.userAppliedTeamsWithoutMatch);
  },

  created() {
    document.body.classList.add('main-background');
    this.accountNeedVerification = this.user_data.accountNotActivated;
  },
};
</script>
